/**
 * Procedure Categories and Procedures for DM in Neuroanaesthesia students
 * Extracted with strict evidence from official NMC PDF (Page 6, 13: "Psychomotor Domain - Procedures in OT and ICU")
 */
export const NEUROANAESTHESIA_PROCEDURES = {
  "Neuro-Airway & Resuscitation Procedures": [
    "Advanced Neuro-Airway Management & Difficult Airway Equipment",
    "Fiberoptic Intubation & Videolaryngoscopy",
    "Surgical & Percutaneous Dilatational Tracheostomy",
    "Bronchoscopy & Bronchoalveolar Sampling in Neuro-ICU",
    "Intercostal Chest Drain Insertion",
  ],
  "Vascular Access, Neuromonitoring & Neuro-ICU Procedures": [
    "Ultrasound-Guided Arterial Line Placement",
    "Ultrasound-Guided Central Venous Line Placement",
    "Application & Interpretation of Transcranial Doppler (TCD)",
    "Care & Monitoring of Invasive Neuromonitoring Equipment (ICP Monitor, EVD, Epilepsy Electrodes)",
    "Patient-Controlled Analgesia (PCA) Pump Management",
    "Bedside Neuro-Ultrasound Applications",
    "Pre-Hospital & Intra-Hospital Transfer of Critical Neurosurgical Patients",
  ],
};

export const NEUROANAESTHESIA_CATEGORIES = Object.keys(NEUROANAESTHESIA_PROCEDURES);

export const isDMInNeuroanaesthesiaDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("neuroanaesthesia") || d.includes("neuroanesthesia") || d.includes("neuro anesthesia");
};
